exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-5eb8e889]{padding:1.2rem 2rem;font-size:1.6rem}.button__text[data-v-5eb8e889]{line-height:0}", ""]);

// exports
